export default "__VITE_ASSET__DxmqGXcF__"